import { BaseService } from './base.service';
import { Injector, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  constructor(
    protected injector: Injector
  ) {
    super(injector);
    this.setBaseCollection('users');
  }

  login({username, password}) {
    return this.db.collection('users', ref => {
      return ref
        .where('username', '==', username)
        .where('password', '==', btoa(password));
    }).snapshotChanges().pipe(
      switchMap(res => {
        if (res[0]) {
          return of({
            id: res[0].payload.doc.id,
            ...res[0].payload.doc.data() as any
          });
        }
        return of('');
      })
    );
  }

}
